module.exports = __webpack_public_path__ + "static/media/temp-persona-8.b8901064.jpg";